import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { AceApiRoute } from '@/urls'

type TypedAxiosInstance = {
  get<T = any, R = AxiosResponse<T>>(url: AceApiRoute, config?: AxiosRequestConfig): Promise<R>
  post<T = any, R = AxiosResponse<T>>(
    url: AceApiRoute,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<R>
  put<T = any, R = AxiosResponse<T>>(
    url: AceApiRoute,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<R>
}

export const aceClient: TypedAxiosInstance = {
  get: (url, config) => axios.get(url, config),
  post: (url, data, config) => axios.post(url, data, config),
  put: (url, data, config) => axios.put(url, data, config),
}
